import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { ReactComponent as Invoice } from "../../../assets/icons/Invoice.svg";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import Table from "../../Table";
import { getPaymentHistoryList } from "../../../utils/apis/accountsApi";
import { useSelector } from "react-redux";
import { formatDateInTimeZone, FormatUSD } from "../../../utils/helpers/string";
import LoaderOverlay from "../../../reusableComponents/LoaderOverlay/Index";

function AccountReceipts() {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef(null);
  const headerRightRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) &&
        headerRightRef.current &&
        !headerRightRef.current.contains(event.target)
      ) {
        setShowCalendar(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleCalendarClick = () => {
    setShowCalendar(!showCalendar);
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };
  const [paymentHistoryList, setPaymentHistoryList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { idToken } = useSelector((state) => state.auth);

  const [params, setParams] = useState({
    page: 1,
    page_size: 20,
  });
  const fetchPaymentHistory = async () => {
    setIsLoading(true);
    try {
      const response = await getPaymentHistoryList(idToken, params); // Assuming getPaymentHistoryList returns a promise
      setPaymentHistoryList(response); // Assuming response.data contains payment history data
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownload = (link) => {
    const anchor = document.createElement("a");
    anchor.href = link;
    anchor.download = "downloaded-file.pdf";
    anchor.target = "_blank";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };
  useEffect(() => {
    fetchPaymentHistory();
  }, [JSON.stringify(params)]);

  const columns = [
    // {
    //   Header: "Account",
    //   accessor: "account",
    //   Cell: ({ value }) => (
    //     <div className="col-wrapper">
    //       <p>{value || "N/A"}</p>
    //     </div>
    //   ),
    // },
    {
      Header: () => (
        <div className="header-with-icon">
          <span>
            Date
            {/* <img src={dropdownIcon} alt="Calendar Icon" /> */}
          </span>
        </div>
      ),
      accessor: "created_at",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>{formatDateInTimeZone(value)}</p>
        </div>
      ),
    },
    { Header: "Payment Id", accessor: "id" },
    { Header: "Funding Evaluation", accessor: "funding_evaluation" },
    {
      Header: () => (
        <div className="header-with-icon">
          <span>Payment status</span>
        </div>
      ),
      accessor: "payment_status",
      Cell: ({ value }) => (
        <button
          // className={`btn-wrapper ${
          //   value === "paids" ? "green-bg-btn" : "red-bg-btn  "
          // }`}
          className={`comp_status ${
            value === "expired"||value === "failed"
              ? "red_status"
              : value === "open"
              ? "yellow_status"
              : value === "succeeded" && "green_status"
          }`}
          style={{ textTransform: "capitalize" }}
        >
          {value}
        </button>
      ),
    },
    {
      Header: "Account Balance",
      accessor: "account_balance",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>{value ? FormatUSD(value) : "N/A"}</p>
        </div>
      ),
    },
    {
      Header: "Payment Types",
      accessor: "payment_type",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p style={{ textTransform: "capitalize" }}>
            {value?.replace("_", " ")}
          </p>
        </div>
      ),
    },
    {
      Header: "Download Invoice",
      accessor: "invoice",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>
            {value ? (
              <Invoice
                onClick={() => handleDownload(value)}
                style={{ cursor: "pointer" }}
              />
            ) : (
              "N/A"
            )}
          </p>
        </div>
      ),
    },
    {
      Header: "Amount",
      accessor: "amount",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>{FormatUSD(value)}</p>
        </div>
      ),
    },
  ];

  if (isLoading) {
    return <LoaderOverlay />;
  }

  if (error) {
    return <p>Error fetching payment history: {error.message}</p>;
  }
  return (
    <div className="account-receipts">
      <div className="ar-header">
        {/* <h2 className="component-heading">Payment History</h2> */}
        {/* <div className="search-wrapper">
          <input type="text" placeholder="Search" />
          <img src={searchIcon} alt="" />
        </div>
        <div className="header-right" ref={headerRightRef}>
          <div className="calendar-dates" onClick={handleCalendarClick}>
            {startDate.toLocaleDateString()} - {endDate.toLocaleDateString()}
          </div>
          <img onClick={handleCalendarClick} src={calendarIcon} alt="" />
        </div> */}
        {showCalendar && (
          <div className="calendar-container" ref={calendarRef}>
            <div>
              <p>From</p>
              <Calendar
                onChange={handleStartDateChange}
                value={startDate}
                className="start-date-calendar"
              />
            </div>
            <div>
              <p>To</p>
              <Calendar
                onChange={handleEndDateChange}
                value={endDate}
                className="end-date-calendar"
              />
            </div>
          </div>
        )}
      </div>

      <div className="ar-table">
        <Table
          columns={columns}
          data={paymentHistoryList || []}
          params={params}
          setParams={setParams}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
}

export default AccountReceipts;
